import { useSaveMember } from './useSaveMember'
import { useSearchCard } from './useSearchCard'

/**
 * クレジットカード決済準備のカスタムフック
 * 会員登録とカード情報取得を行う
 * @returns {Object} セットアップ関数とステート
 */
export const useCreditCardSetup = () => {
  const { saveMember, isLoading: isSavingMember } = useSaveMember()
  const { searchCard, isLoading: isSearchingCard } = useSearchCard()

  const setup = async () => {
    await saveMember()
    const response = await searchCard()

    const hasCard = response.card && Object.keys(response.card).length > 0

    if (!hasCard) {
      return { hasCard: false, cardInfo: null }
    }

    const cardNo = response.card.CardNo || ''
    const cardInfo = {
      cardNo,
      last4: cardNo.slice(-4),
      expire: response.card.Expire,
    }

    return { hasCard: true, cardInfo }
  }

  return {
    setup,
    isLoading: isSavingMember || isSearchingCard,
  }
}
